export default {
  "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wiki"])},
  "shortcut-count": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["1 shortcut"]), _normalize([_interpolate(_named("count")), " shortcuts"])])},
  "command-count": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["1 command"]), _normalize([_interpolate(_named("count")), " commands"])])},
  "pages": [
    {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Key assignment"])},
      "route": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["keyboard"])},
      "icon": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mdi-keyboard"])}
    },
    {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Commands"])},
      "route": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["commands"])},
      "icon": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mdi-slash-forward"])}
    },
    {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crime Minigames"])},
      "route": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["crimeminigames"])},
      "icon": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mdi-controller"])}
    }
  ],
  "keys": {
    "mouse-right": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Right click"])}
  },
  "keyboard": {
    "shortcuts": [
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shift"])},
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mouse-right"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Interaction with players, vehicles, doors and bins"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["F12"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Change character"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Starting the engine"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Remotely open and close the vehicle"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["R"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reload weapon"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Y"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Weapon Remove magazine"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["B"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Switch weapon fire mode"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Z"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lie down"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NUMPAD 1-9"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Animations like waving, hands out and hands up"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["V"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Open animation wheel"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["X"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adjust voice volume"])}
      }
    ]
  },
  "commands": {
    "/l": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Coming back to the lobby"])},
    "/unverify": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De-verify your Teamspeak identity"])},
    "/log": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create a log in the RP to report other players"])},
    "/account-verify": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Link your website account to your Minecraft account"])},
    "/discord-verify": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Link your Discord account to your Minecraft account"])},
    "/discord-unlink": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Disconnect from your Discord account"])},
    "/id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shows you your own network ID"])},
    "/playtime": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To check your playing time"])},
    "/vote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["With this you can vote for our server to get a reward"])},
    "/fix dynamx": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Use this command if vehicles or objects are not displayed correctly"])},
    "/fix skin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fixes visual errors on all skins"])},
    "/online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shows the number of players on the network or on the current server"])}
  },
  "crimeminigames": [
    {
      "image": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Labyrinth"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Labyrinth Minigame"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guide the blue line through the maze to the red target using the arrow keys. The line moves continuously and you must actively steer it through the open black paths. If you touch a grey wall, you lose a life."])}
    },
    {
      "image": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lockpick"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lockpick Minigame"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A red marker rotates clockwise around the ring. As soon as it hits the blue dot, press the spacebar. The direction then reverses and the blue dot appears at a new position. Repeat until the lock is cracked. Too slow or missed – and you lose an attempt."])}
    },
    {
      "image": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Propangas"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Propane Gas Minigame"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hold spacebar / left mouse button to pump gas into the machine – a blue bar rises from bottom to top. Release the key once the bar is in the green zone. If it enters the red zone, the ATM explodes and the mission fails."])}
    },
    {
      "image": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["BruteForce"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brute Force Minigame"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Characters fall from top to bottom through the grid. When a red character reaches the middle red line, press spacebar / left mouse button. A hit moves the blue bar one column to the right. Complete all columns and the hack succeeds. Miss too many red characters and the break-in fails."])}
    }
  ]
}